module.exports = __webpack_public_path__ + "static/media/Setup-02.b7deb239.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Setup-02.mp3
// module id = 528
// module chunks = 0